module.exports = __webpack_public_path__ + "img/EH.1ecda832.svg";